import { Routes } from '@angular/router';
import { salesRoutes } from './pages/sales/sales-routing.module';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthLoginGuard } from './core/guards/auth-login.guard';
import { InventoryLotsRoutes } from './pages/inventory-lots/inventory-lots-routing.module';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [AuthLoginGuard],
    loadComponent: () =>
      import('./pages/auth/login/login.component').then((m) => m.default),
  },

  {
    path: '',
    loadComponent: () =>
      import('./pages/layout/layout.component').then((m) => m.default),
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'vender', pathMatch: 'full' },

      // {path: '', loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.default),},
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.default
          ),
      },

      {
        path: 'vender',
        loadComponent: () =>
          import('./pages/sale/sell/sell.component').then((m) => m.default),
      },
      {
        path: 'clientes',
        loadComponent: () =>
          import('./pages/customer/index/index.component').then(
            (m) => m.default
          ),
      },
      {
        path: 'productos',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/product/index/index.component').then(
                (m) => m.default
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/product/show/show.component').then(
                (m) => m.ProductShowComponent
              ),
          },
        ],
      },
      {
        path: 'catalogo-productos',
        loadComponent: () =>
          import('./pages/product-catalog/index-product-catalog/product-catalog.component').then(
            (m) => m.default
          ),
      },
      {
        path: 'almacenes',
        loadComponent: () =>
          import('./pages/warehouse/index/warehouse-index.component').then(
            (m) => m.default
          ),
      },
      {
        path: 'traspasos',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/transfers/index/transfers-index.component').then(
                (m) => m.default
              ),
          },
          {
            path: 'crear',
            loadComponent: () =>
              import('./pages/transfers/create/transfer-create.component').then(
                (m) => m.default
              ),
          },
          {
            path: 'detalle/:id',
            loadComponent: () =>
              import('./pages/transfers/detail/transfer-detail.component').then(
                (m) => m.default
              ),
          },
        ],
      },
      {
        path: 'reportes',
        loadComponent: () =>
          import('./pages/reportes/reportes.component').then((m) => m.default),
      },
      {
        path: 'productos-reparacion',
        loadComponent: () =>
          import('./pages/repairing-products/index/index.component').then(
            (m) => m.default
          ),
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./pages/category/index/index.component').then(
            (m) => m.default
          ),
      },
      {
        path: 'marcas',
        loadComponent: () =>
          import('./pages/brand/index/index.component').then((m) => m.default),
      },
      {
        path: 'grupos',
        loadComponent: () =>
          import('./pages/group/index/index.component').then((m) => m.default),
      },

      { path: 'ventas', children: salesRoutes },
      {
        path: 'venta/:id',
        loadComponent: () =>
          import('./pages/sales/sale-detail/sale-detail.component').then(
            (m) => m.default
          ),
      },

      { path: 'inventario', children: InventoryLotsRoutes },
      {
        path: 'usuarios',
        loadComponent: () =>
          import('./pages/user/index/index.component').then((m) => m.default),
      },
      {
        path: 'soporte',
        loadComponent: () =>
          import('./pages/support/index.component').then((m) => m.default),
      },
      {
        path: 'configuracion',
        loadComponent: () =>
          import('./pages/settings/setting.component').then((m) => m.default),
      },
      {
        path: 'web-config',
        loadComponent: () =>
          import('./pages/web-config/web.component').then((m) => m.default),
      },
      {
        path: 'ofertas',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/offer/offer-product/offer-product.component').then((m) => m.default),
          },
          {
            // Crear y editar en página completa: formulario a la izquierda y vista previa de la web a la derecha.
            path: 'nueva',
            loadComponent: () =>
              import('./pages/offer/offer-editor/offer-editor.component').then((m) => m.default),
          },
          {
            path: 'editar/:id',
            loadComponent: () =>
              import('./pages/offer/offer-editor/offer-editor.component').then((m) => m.default),
          },
        ],
      },
      {
        // SuperAdmin y Administrador: el backend valida el rol (coupons).
        path: 'cupones',
        loadComponent: () => import('./pages/coupons/coupons-index.component').then((m) => m.default),
      },
      {
        // SuperAdmin y Administrador: el backend valida el rol (qualifications/admin).
        path: 'calificaciones',
        loadComponent: () =>
          import('./pages/qualifications/qualifications-index.component').then((m) => m.default),
      },
      {
        // Solo SuperAdmin: el backend valida el rol en cada endpoint del historial.
        path: 'historial-ingresos',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/inventory-entries/index/inventory-entries-index.component').then(
                (m) => m.default
              ),
          },
          {
            path: 'detalle/:id',
            loadComponent: () =>
              import('./pages/inventory-entries/detail/inventory-entry-detail.component').then(
                (m) => m.default
              ),
          },
        ],
      }
    ],
  },
  // { path: '**', redirectTo: 'login', pathMatch: 'full' },

  // { path: '', redirectTo: 'login', pathMatch: 'full' },
];
